import { TFunction } from 'i18next';
import { Department } from 'graphql-common';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';

type ActionsMenuArgs = {
  onView: (v?: Department) => void;
  onEdit: (v?: Department) => void;
  onDelete: (v?: Department) => void;
  isViewOnly: boolean;
  t: TFunction<'translation', undefined>;
};

export default function getDepartmentsTableActionsMenu({
  onView,
  onEdit,
  onDelete,
  isViewOnly,
  t,
}: ActionsMenuArgs): NavItem<Department>[] {
  return [
    {
      id: 'view-action',
      title: t('view'),
      onClick: (item?: Department) => onView(item),
      leftIcon: Icons.view,
      type: NavItemTypeEnum.Secondary,
    },
    {
      id: 'edit-action',
      title: t('edit'),
      onClick: (item?: Department) => onEdit(item),
      leftIcon: Icons.edit,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: () => !isViewOnly,
    },
    {
      id: 'delete-action',
      title: t('delete'),
      onClick: (item?: Department) => onDelete(item),
      leftIcon: Icons.delete,
      type: NavItemTypeEnum.Secondary,
      predictorFnVisible: (item) => !isViewOnly && !!item?.canDestroy?.value,
    },
  ];
}
